import React, { useMemo } from 'react';
import './progress-bar.css';

const ProgressBar = ({ currentStep, selections, configData }) => {
  const { progressPercentage } = useMemo(() => {

    if (!currentStep || !configData || !configData.steps) {
      return { progressPercentage: 0, currentStepNumber: 0, totalSteps: 0 };
    }

    const currentStepConfig = configData.steps.find(step => step.name === currentStep);
    
    
    if (!currentStepConfig && currentStep !== 'f-final') {
      return { progressPercentage: 0, currentStepNumber: 0, totalSteps: 0 };
    }
    
    const sexe = currentStepConfig?.sexe || 'femme';
    
    let totalPathSteps = 0;
    let currentStepNumber = 0;
    
    if (sexe === 'femme' || currentStep === 'f-final') {
      const initialSelection = selections['f-0'];
      
      totalPathSteps = 5;
      
      if (initialSelection && initialSelection.choice) {
        const firstChoice = initialSelection.choice;
        if (firstChoice.label === "Coloration") {
          totalPathSteps = 6;
        } else if (firstChoice.label === "Gloss") {
          totalPathSteps = 5;
        } else if (firstChoice.label === "Brushing") {
          totalPathSteps = 5;
        }
      }
      
      totalPathSteps += 1;
      
      if (currentStep === 'f-0') {
        currentStepNumber = 1;
      } else if (currentStep === 'f-final') {
        currentStepNumber = totalPathSteps;
      } else if (currentStep === 'modal') {
        currentStepNumber = totalPathSteps - 1;
      } else {
        const stepMatch = currentStep.match(/f-[a-z]-(\d+)/);
        if (stepMatch && stepMatch[1]) {
          currentStepNumber = parseInt(stepMatch[1]) + 2;
        }
      }
    } 
    else if (sexe === 'homme') {
      let hommePathType = '';
      

      if (currentStep.startsWith('h-b-c-')) hommePathType = 'barbe-cheveux';
      else if (currentStep.startsWith('h-b-')) hommePathType = 'barbe';
      else if (currentStep.startsWith('h-c-')) hommePathType = 'cheveux';
      
      if (hommePathType === 'barbe-cheveux') {
        totalPathSteps = 3;
        
        if (currentStep === 'h-1') {
          currentStepNumber = 1;
        } else if (currentStep === 'h-b-c-1') {
          currentStepNumber = 2;
        } else if (currentStep === 'h-b-c-2') {
          currentStepNumber = 3;
        } else if (currentStep === 'f-final') {
          currentStepNumber = 4;
        }
      } else if (hommePathType === 'barbe') {
        totalPathSteps = 2;
        
        if (currentStep === 'h-1') {
          currentStepNumber = 1;
        } else if (currentStep === 'h-b-1') {
          currentStepNumber = 2;
        } else if (currentStep === 'f-final') {
          currentStepNumber = 3;
        }
      } else if (hommePathType === 'cheveux') {
        totalPathSteps = 2;
        
        if (currentStep === 'h-1') {
          currentStepNumber = 1;
        } else if (currentStep === 'h-c-1') {
          currentStepNumber = 2;
        } else if (currentStep === 'f-final') {
          currentStepNumber = 3;
        }
      } else if (currentStep === 'h-1') {
        currentStepNumber = 1;
        totalPathSteps = 2;
      }
    }
    
    if (currentStep === 'f-final') {
      if (currentStepNumber === 0) {
        const histoire = Object.keys(selections);
        const derniereEtape = histoire[histoire.length - 1];
        
        if (derniereEtape && derniereEtape.startsWith('h-b-c-')) {
          currentStepNumber = 4;
          totalPathSteps = 3;
        } else if (derniereEtape && (derniereEtape.startsWith('h-b-') || derniereEtape.startsWith('h-c-'))) {
          currentStepNumber = 3;
          totalPathSteps = 2;
        } else {
          currentStepNumber = 6;
          totalPathSteps = 5;
        }
      }
    }
    
    const minProgress = 20;
    
    let progressPercentage;
    if (totalPathSteps <= 1) {
      progressPercentage = currentStep === 'f-final' ? 100 : minProgress;
    } else {
      progressPercentage = minProgress + ((currentStepNumber - 1) / (totalPathSteps)) * (100 - minProgress);
      
      if (currentStep === 'f-final') {
        progressPercentage = 100;
      }
    }
    
    progressPercentage = Math.min(100, Math.max(0, progressPercentage));
    
    return { 
      progressPercentage, 
      currentStepNumber,
      totalSteps: totalPathSteps + 1
    };
  }, [currentStep, selections, configData]);

  return (
    <div className="progress-bar-container">
      <div 
        className="progress-bar-fill"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;